import { CLASSES } from '../utils/constants';

const initRecipeTabs = (section = document) => {
  const ingredientsBtn = section.querySelector('[data-recipe-ingredients-btn]');
  const instructionsBtn = section.querySelector('[data-recipe-instructions-btn]');
  const ingredientsEl = section.querySelector('[data-recipe-ingredients]');
  const instructionsEl = section.querySelector('[data-recipe-instructions]');

  if (!ingredientsBtn || !instructionsBtn) return;

  const showIngredients = () => {
    ingredientsEl?.classList.remove(CLASSES.HIDDEN);
    instructionsEl?.classList.add(CLASSES.HIDDEN);
    ingredientsBtn.classList.add(CLASSES.BG_GHOST, CLASSES.BORDER_GHOST);
    instructionsBtn.classList.remove(CLASSES.BG_GHOST, CLASSES.BORDER_GHOST);
  };

  const showInstructions = () => {
    instructionsEl?.classList.remove(CLASSES.HIDDEN);
    ingredientsEl?.classList.add(CLASSES.HIDDEN);
    instructionsBtn.classList.add(CLASSES.BG_GHOST, CLASSES.BORDER_GHOST);
    ingredientsBtn.classList.remove(CLASSES.BG_GHOST, CLASSES.BORDER_GHOST);
  };

  ingredientsBtn.addEventListener('click', showIngredients);
  instructionsBtn.addEventListener('click', showInstructions);
};

export default initRecipeTabs;
